import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState, useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import UIModal from 'UIComponents/dialog/UIModal';
import UIWizard from 'UIComponents/dialog/UIWizard';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import Review from '../../records/Review';
export function BaseReviewWizard({
  dataTestId,
  HeaderComponent,
  StepComponents,
  defaultReview = new Review(),
  disableSubmit = false,
  failed,
  loading,
  onReject,
  onConfirm,
  onChange,
  onStepChange,
  onWizardLoad,
  reviewSteps,
  // TODO deprecate once quality ratings are ungated
  reviewType,
  submitTooltip
}) {
  useEffect(() => {
    if (onWizardLoad) {
      onWizardLoad();
    }
  }, [onWizardLoad]);
  const [review, setReview] = useState(defaultReview);
  const [step, setStep] = useState(reviewSteps[0]);
  const [checkedLegalDisclaimer, setCheckedLegalDisclaimer] = useState(false);
  const onUpdateReview = useCallback(updates => {
    if (Object.prototype.hasOwnProperty.call(updates, 'checkedLegalDisclaimer')) {
      setCheckedLegalDisclaimer(updates.checkedLegalDisclaimer);
    } else {
      const {
        content,
        ratings
      } = updates;

      if (content) {
        updates.content = new Map(Object.entries(content));
      }

      if (ratings) {
        updates.ratings = new Map(Object.entries(ratings));
      }

      const updatedReview = review.updateReview(updates);
      setReview(updatedReview);

      if (onChange) {
        onChange(updatedReview);
      }
    }
  }, [review, onChange]);
  return /*#__PURE__*/_jsx(UIModal, {
    "data-test-id": dataTestId,
    use: "fullscreen",
    children: /*#__PURE__*/_jsx(UIWizard, {
      cancellable: true,
      defaultDoneButton: buttonProps => /*#__PURE__*/_jsx(UITooltip, {
        title: submitTooltip,
        disabled: !disableSubmit || !submitTooltip,
        children: /*#__PURE__*/_jsx(UILoadingButton, Object.assign({}, buttonProps, {
          disabled: disableSubmit || buttonProps.disabled,
          loading: loading,
          failed: failed
        }))
      }),
      defaultDoneLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-reviews.wizard.submit"
      }),
      disablePrimaryButton: !review.isStepComplete(reviewType, step, checkedLegalDisclaimer),
      headerComponent: HeaderComponent,
      onReject: onReject,
      onConfirm: () => {
        onConfirm(review).then(() => {
          FloatingAlertStore.addAlert({
            message: unescapedText('marketplace-ui-reviews.wizard.alert.submit.message'),
            titleText: unescapedText('marketplace-ui-reviews.wizard.alert.submit.title'),
            type: 'success'
          });
        }).catch(() => {
          FloatingAlertStore.addAlert({
            message: unescapedText('marketplace-ui-reviews.wizard.alert.error.message'),
            titleText: unescapedText('marketplace-ui-reviews.wizard.alert.error.title'),
            type: 'danger'
          });
        });
      },
      onStepIndexChange: ({
        target: {
          value
        }
      }) => {
        const nextStep = reviewSteps[value];
        setStep(nextStep);

        if (onStepChange) {
          onStepChange(step, nextStep);
        }
      },
      children: StepComponents.map((Component, index) => /*#__PURE__*/_jsx(Component, {
        name: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `marketplace-ui-reviews.wizard.steps.${reviewSteps[index]}`
        }, index),
        review: review,
        onUpdate: onUpdateReview,
        checkedLegalDisclaimer: checkedLegalDisclaimer
      }, index))
    })
  });
}
export default BaseReviewWizard;